import { Component, inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { ClientsService } from "@services/clients.service";
import { take } from "rxjs";

export interface StoreClientRequestData {
  company_name: string;
  user: {
    first_name: string;
    last_name: string;
    email: string;
    phone_number: string;
    phone_prefix: string;
    company_position: string;
  };
}

@Component({
  selector: "app-client-dialog",
  templateUrl: "./client-dialog.component.html",
  styleUrls: ["./client-dialog.component.scss"],
})
export class ClientDialogComponent {
  dialogRef = inject(MatDialogRef<ClientDialogComponent>);
  clientService = inject(ClientsService);

  clientForm = new FormGroup({
    company_name: new FormControl("", [
      Validators.required,
      Validators.maxLength(191),
    ]),
    user: new FormGroup({
      first_name: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      last_name: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      email: new FormControl("", [
        Validators.required,
        Validators.email,
        Validators.maxLength(128),
      ]),
      phone_number: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      phone_prefix: new FormControl("", [
        Validators.required,
        Validators.maxLength(128),
      ]),
      company_position: new FormControl("", [Validators.maxLength(128)]), // Optional field
    }),
  });

  constructor() {}

  submit(): void {
    this.clientForm.markAllAsTouched(); // Mark all fields as touched to show validation errors
    if (this.clientForm.invalid) {
      return;
    }

    // Convert form data to client format
    const formData = this.clientForm.value as StoreClientRequestData;

    this.clientService
      .storeClient(formData)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.dialogRef.close({
            client: response,
          }); // Close the dialog on successful submission
        },
        error: (error) => {
          console.error("Error saving client:", error);
          // Handle error appropriately, e.g., show an alert
        },
      });
  }
}
